// extracted by mini-css-extract-plugin
export default {"container":"AddNewEventFieldPanel_container__Kd0a6","label":"AddNewEventFieldPanel_label__zMJad"};